import { reopened, pending, reviewed } from './reviewstatus';

export var willNeedReviewAsReviewer = 'willNeedReviewAsReviewer';
export var reopenedReviewAsReviewer = 'reopenedReviewAsReviewer';
export var needReviewAsReviewer = 'needReviewAsReviewer';
export var reviewedReviewAsReviewer = 'reviewedReviewAsReviewer';
export var needReviewAsAssignee = 'needReviewAsAssignee';
export var reviewedReviewAsAssignee = 'reviewedReviewAsAssignee';
export var reopenedReviewAsAssignee = 'reopenedReviewAsAssignee';

export var getReviewHeaderType = function getReviewHeaderType(_ref) {
  var isAssignee = _ref.isAssignee,
      isReviewer = _ref.isReviewer,
      reviewStatus = _ref.reviewStatus,
      hasReviewerWithStatusPending = _ref.hasReviewerWithStatusPending,
      hasReviewerWithStatusReopened = _ref.hasReviewerWithStatusReopened,
      isReviewedByAllReviewers = _ref.isReviewedByAllReviewers;

  if (isReviewer && !reviewStatus) {
    return willNeedReviewAsReviewer;
  }

  if (isReviewer && reviewStatus === reopened) {
    return reopenedReviewAsReviewer;
  }

  if (isReviewer && reviewStatus === pending) {
    return needReviewAsReviewer;
  }

  if (isReviewer && reviewStatus === reviewed) {
    return reviewedReviewAsReviewer;
  }

  if (isAssignee && hasReviewerWithStatusReopened) {
    return reopenedReviewAsAssignee;
  }

  if (isAssignee && hasReviewerWithStatusPending) {
    return needReviewAsAssignee;
  }

  if (isAssignee && isReviewedByAllReviewers) {
    return reviewedReviewAsAssignee;
  }

  return null;
};
//# sourceMappingURL=taskpanel.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/taskpanel.js
// module id = 777
// module chunks = 0